import type { TrialStatus } from '@st/contract';
import { useTranslation } from '../i18n/I18nProvider';
import { isTrialActive, trialRemainingKey } from '../lib/trial';
import { cx } from '../lib/cx';

/**
 * Traka „još N besplatna treninga”. Vidi se samo dok probni pristup traje —
 * plaćeni klijent nikad ne dobiva podsjetnik na nešto što je već riješio.
 */
export function TrialBanner({
  status,
  className,
}: {
  status: TrialStatus | undefined;
  className?: string;
}) {
  const { t } = useTranslation();
  if (!isTrialActive(status) || !status?.trial) return null;

  const { remaining, used, total } = status.trial;

  return (
    <div
      data-testid="trial-banner"
      className={cx(
        'flex flex-wrap items-center justify-between gap-3 rounded-xl border border-accent/40',
        'bg-accent-light px-4 py-3',
        className,
      )}
    >
      <p className="text-[14px] text-ink">
        <strong className="font-medium">{t(trialRemainingKey(remaining), { n: remaining })}</strong>
        <span className="ml-2 text-ink-muted">{t('trial.bannerHelp')}</span>
      </p>
      <span className="text-[12px] text-ink-muted">{t('trial.used', { used, total })}</span>
    </div>
  );
}
